// src/capacitor/deep-link-listener.tsx
import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { useNavigate, useLocation } from 'react-router-dom';
import { isMobileApp } from '@common/core/platform-detection';
import { PluginListenerHandle } from '@capacitor/core';

export function DeepLinkListener() {
  const navigate = useNavigate();
  const { pathname: current } = useLocation();

  useEffect(() => {
    if (!isMobileApp()) return;

    let listener: PluginListenerHandle | undefined;

    // on enferme l’async/await dans une IIFE pour ne pas rendre useEffect async
    (async () => {
        listener = await App.addListener('appUrlOpen', ({ url }) => handleUrl(url));
    })();

    App.getLaunchUrl().then(res => res?.url && handleUrl(res.url));

    return () => {
        listener?.remove(); // sera défini une fois la promesse résolue
    };
    }, [navigate]);

  const handleUrl = (url: string) => {
    try {
      const { pathname, search } = new URL(url);
      const target = `${pathname}${search}`;

      // évite de pousser la même route
      if (target !== current) {
        navigate(target, { replace: true });
      }
    } catch (e) {
      console.error('[DeepLinkListener] URL invalide', e);
    }
  };

  return null; // composant “fantôme”
}
